import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "FormSection" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "FormSectionHeading" }, "Basic Information", -1 /* HOISTED */)
const _hoisted_3 = { class: "FormSection" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", { class: "FormSectionHeading" }, "Links", -1 /* HOISTED */)
const _hoisted_5 = { class: "FormSection" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", { class: "FormSectionHeading" }, "Chain Scholarship", -1 /* HOISTED */)
const _hoisted_7 = { class: "FormSection" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h4", { class: "FormSectionHeading" }, "Overview", -1 /* HOISTED */)
const _hoisted_9 = { class: "FormSection" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h4", { class: "FormSectionHeading" }, "Detailed Facts", -1 /* HOISTED */)
const _hoisted_11 = { class: "FormSection" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h4", { class: "FormSectionHeading" }, "Destination", -1 /* HOISTED */)
const _hoisted_13 = { class: "FormSection" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h4", { class: "FormSectionHeading" }, "Origin", -1 /* HOISTED */)
const _hoisted_15 = { class: "FormSection" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h4", { class: "FormSectionHeading" }, "Requirements", -1 /* HOISTED */)
const _hoisted_17 = { class: "FormSection" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h4", { class: "FormSectionHeading" }, "Application Process", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_ProviderEditor = _resolveComponent("ProviderEditor")!
  const _component_HtmlEditor = _resolveComponent("HtmlEditor")!
  const _component_MassSelect = _resolveComponent("MassSelect")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_DeadlineEditor = _resolveComponent("DeadlineEditor")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_ctx.formModel)
    ? (_openBlock(), _createBlock(_component_el_container, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form, {
            model: _ctx.formModel,
            "label-width": "200px",
            ref: "formRef",
            rules: _ctx.rules
          }, {
            default: _withCtx(() => [
              _createElementVNode("fieldset", _hoisted_1, [
                _hoisted_2,
                _createVNode(_component_el_form_item, {
                  prop: "title",
                  label: "Title"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formModel.title,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formModel.title) = $event)),
                      class: "full-width"
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _createElementVNode("fieldset", _hoisted_3, [
                _hoisted_4,
                _createVNode(_component_el_form_item, {
                  prop: "sourceUrl",
                  label: "Source Url"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formModel.sourceUrl,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formModel.sourceUrl) = $event)),
                      class: "full-width"
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_el_form_item, {
                  prop: "foundAtUrl",
                  label: "Secondary Url"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formModel.foundAtUrl,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formModel.foundAtUrl) = $event)),
                      class: "full-width"
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _createElementVNode("fieldset", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_el_form_item, {
                  prop: "provider",
                  label: "Provider"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ProviderEditor, {
                      modelValue: _ctx.formModel.provider,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formModel.provider) = $event))
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _createElementVNode("fieldset", _hoisted_7, [
                _hoisted_8,
                _createVNode(_component_el_form_item, {
                  prop: "summary",
                  label: "Summary"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_HtmlEditor, {
                      modelValue: _ctx.formModel.summary,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formModel.summary) = $event)),
                      onEditorBlurred: _cache[5] || (_cache[5] = ($event: any) => (_ctx.validateField('summary'))),
                      class: "full-width"
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_el_form_item, {
                  prop: "description",
                  label: "Description"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_HtmlEditor, {
                      modelValue: _ctx.formModel.description,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formModel.description) = $event)),
                      formattingOptions: "STRONG H4 H5 H6 UL",
                      onEditorBlurred: _cache[7] || (_cache[7] = ($event: any) => (_ctx.validateField('description'))),
                      class: "full-width"
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_el_form_item, {
                  prop: "benefits",
                  label: "Benefits"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_HtmlEditor, {
                      modelValue: _ctx.formModel.benefits,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formModel.benefits) = $event)),
                      formattingOptions: "STRONG H4 H5 H6 UL",
                      onEditorBlurred: _cache[9] || (_cache[9] = ($event: any) => (_ctx.validateField('benefits'))),
                      class: "full-width"
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _createElementVNode("fieldset", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_el_form_item, {
                  prop: "disciplines",
                  label: "Disciplines"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_MassSelect, {
                      modelValue: _ctx.formModel.disciplines,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formModel.disciplines) = $event)),
                      selectableData: _ctx.relatedData.disciplines,
                      separator: ";",
                      placeholder: "Discipline names, semicolon separated: Agriculture; Hospitality, Leisure & Sports",
                      onEditorBlurred: _cache[11] || (_cache[11] = ($event: any) => (_ctx.validateField('disciplines')))
                    }, null, 8 /* PROPS */, ["modelValue", "selectableData"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_el_form_item, { label: "Degrees" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.formModel.degrees,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formModel.degrees) = $event)),
                      placeholder: "please select",
                      class: "full-width",
                      multiple: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relatedData.degrees, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: item.label,
                            value: item.value,
                            key: item.value
                          }, null, 8 /* PROPS */, ["label", "value"]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_el_form_item, { label: "Format" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.formModel.formats,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formModel.formats) = $event)),
                      placeholder: "please select",
                      class: "full-width",
                      multiple: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relatedData.formats, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: item.label,
                            value: item.value,
                            key: index
                          }, null, 8 /* PROPS */, ["label", "value"]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_el_form_item, { label: "Type" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.formModel.types,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formModel.types) = $event)),
                      placeholder: "please select",
                      class: "full-width",
                      multiple: "",
                      filterable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relatedData.types, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: item.label,
                            value: item.value,
                            key: index
                          }, null, 8 /* PROPS */, ["label", "value"]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_el_form_item, { label: "Grant Amount" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: _ctx.formModel.grantAmount,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formModel.grantAmount) = $event)),
                      precision: 2,
                      step: 1.0,
                      class: "full-width"
                    }, null, 8 /* PROPS */, ["modelValue", "step"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_el_form_item, { label: "Grant Currency" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.formModel.grantCurrencyIso.inputValue,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formModel.grantCurrencyIso.inputValue) = $event)),
                      placeholder: "please select",
                      class: "full-width",
                      filterable: "",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relatedData.currencies, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: item.label,
                            value: item.value,
                            key: item.value
                          }, null, 8 /* PROPS */, ["label", "value"]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_el_form_item, {
                  prop: "grantDescription",
                  label: "Grant Description"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formModel.grantDescription,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formModel.grantDescription) = $event)),
                      maxlength: "50",
                      class: "full-width"
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_el_form_item, {
                  prop: "isAwardedMultipleTimes",
                  label: "Is Awarded multiple times"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_group, {
                      modelValue: _ctx.formModel.isAwardedMultipleTimes,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formModel.isAwardedMultipleTimes) = $event)),
                      class: "full-width"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio, { label: true }, {
                          default: _withCtx(() => [
                            _createTextVNode("True")
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_el_radio, { label: false }, {
                          default: _withCtx(() => [
                            _createTextVNode("False")
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _createElementVNode("fieldset", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_el_form_item, {
                  prop: "destinationCountries",
                  label: "Destination Countries"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_MassSelect, {
                      modelValue: _ctx.formModel.destinationCountries,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formModel.destinationCountries) = $event)),
                      selectableData: _ctx.relatedData.destinationCountries,
                      placeholder: "Country names, semicolon separated: Netherlands; Romania; United States",
                      separator: ";",
                      onEditorBlurred: _cache[20] || (_cache[20] = ($event: any) => (_ctx.validateField('destinationCountries'))),
                      onAllSelected: _cache[21] || (_cache[21] = ($event: any) => (_ctx.onAllDestinationCountriesSelected()))
                    }, null, 8 /* PROPS */, ["modelValue", "selectableData"])
                  ]),
                  _: 1 /* STABLE */
                }),
                (_ctx.showDestinationStates)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      prop: "destinationStates",
                      label: "Destination States"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_MassSelect, {
                          modelValue: _ctx.formModel.destinationStates,
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formModel.destinationStates) = $event)),
                          selectableData: _ctx.relatedData.destinationStates,
                          placeholder: "State names, comma separated: Scotland, California",
                          onEditorBlurred: _cache[23] || (_cache[23] = ($event: any) => (_ctx.validateField('destinationStates')))
                        }, null, 8 /* PROPS */, ["modelValue", "selectableData"])
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("fieldset", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_el_form_item, {
                  prop: "originCountries",
                  label: "Origin Countries"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_MassSelect, {
                      modelValue: _ctx.formModel.originCountries,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formModel.originCountries) = $event)),
                      selectableData: _ctx.relatedData.originCountries,
                      placeholder: "Country names, semicolon separated: Netherlands; Romania; United States",
                      separator: ";",
                      onEditorBlurred: _cache[25] || (_cache[25] = ($event: any) => (_ctx.validateField('originCountries'))),
                      onAllSelected: _cache[26] || (_cache[26] = ($event: any) => (_ctx.onAllOriginCountriesSelected()))
                    }, null, 8 /* PROPS */, ["modelValue", "selectableData"])
                  ]),
                  _: 1 /* STABLE */
                }),
                (_ctx.showOriginStates)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      prop: "originStates",
                      label: "Origin States"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_MassSelect, {
                          modelValue: _ctx.formModel.originStates,
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.formModel.originStates) = $event)),
                          selectableData: _ctx.relatedData.originStates,
                          placeholder: "State names, comma separated: Scotland, California",
                          onEditorBlurred: _cache[28] || (_cache[28] = ($event: any) => (_ctx.validateField('originStates')))
                        }, null, 8 /* PROPS */, ["modelValue", "selectableData"])
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("fieldset", _hoisted_15, [
                _hoisted_16,
                _createVNode(_component_el_form_item, { label: "Minimum Experience" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.formModel.minimumExperience.inputValue,
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.formModel.minimumExperience.inputValue) = $event)),
                      placeholder: "please select",
                      class: "full-width",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relatedData.studyExperience, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: item.label,
                            value: item.value,
                            key: item.value
                          }, null, 8 /* PROPS */, ["label", "value"]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_el_form_item, { label: "Gender" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.formModel.gender.inputValue,
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.formModel.gender.inputValue) = $event)),
                      placeholder: "please select",
                      class: "full-width",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relatedData.gender, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: item.label,
                            value: item.value,
                            key: index
                          }, null, 8 /* PROPS */, ["label", "value"]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_el_form_item, { label: "Age Min" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: _ctx.formModel.ageMin,
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.formModel.ageMin) = $event)),
                      min: 1,
                      class: "full-width"
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_el_form_item, { label: "Age Max" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: _ctx.formModel.ageMax,
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.formModel.ageMax) = $event)),
                      min: _ctx.formModel.ageMin || 1,
                      class: "full-width"
                    }, null, 8 /* PROPS */, ["modelValue", "min"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_el_form_item, { label: "Race" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.formModel.race.inputValue,
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.formModel.race.inputValue) = $event)),
                      placeholder: "please select",
                      class: "full-width",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relatedData.race, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: item.label,
                            value: item.value,
                            key: index
                          }, null, 8 /* PROPS */, ["label", "value"]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_el_form_item, { label: "Application Basis" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.formModel.applicationBasis,
                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.formModel.applicationBasis) = $event)),
                      placeholder: "please select",
                      multiple: "",
                      class: "full-width"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relatedData.applicationBasis, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: item.label,
                            value: item.value,
                            key: index
                          }, null, 8 /* PROPS */, ["label", "value"]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_el_form_item, {
                  prop: "eligibility",
                  label: "Eligibility"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_HtmlEditor, {
                      modelValue: _ctx.formModel.eligibility,
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.formModel.eligibility) = $event)),
                      formattingOptions: "STRONG H4 H5 H6 UL",
                      onEditorBlurred: _cache[36] || (_cache[36] = ($event: any) => (_ctx.validateField('eligibility'))),
                      class: "full-width"
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _createElementVNode("fieldset", _hoisted_17, [
                _hoisted_18,
                _createVNode(_component_el_form_item, {
                  label: "Application Form Url",
                  prop: "applicationFormUrl"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formModel.applicationFormUrl,
                      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.formModel.applicationFormUrl) = $event)),
                      class: "full-width"
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_el_form_item, {
                  prop: "applicationInfo",
                  label: "How to Apply"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_HtmlEditor, {
                      modelValue: _ctx.formModel.applicationInfo,
                      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.formModel.applicationInfo) = $event)),
                      formattingOptions: "STRONG H4 H5 H6 UL",
                      onEditorBlurred: _cache[39] || (_cache[39] = ($event: any) => (_ctx.validateField('applicationInfo'))),
                      class: "full-width"
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_el_form_item, {
                  prop: "deadline",
                  label: "Deadline"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DeadlineEditor, {
                      modelValue: _ctx.formModel.deadline,
                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.formModel.deadline) = $event)),
                      onEditorBlurred: _cache[41] || (_cache[41] = ($event: any) => (_ctx.validateField('deadline')))
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                })
              ])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["model", "rules"])
        ]),
        _: 1 /* STABLE */
      }))
    : _createCommentVNode("v-if", true)
}